import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import type { AxiosInstance } from "axios";

export interface BindProvincia {
  id: number;
  name: string;
}

export interface BindLocalidad {
  id: number;
  name: string;
  externalCode?: string;
}

let bindApiPromise: Promise<AxiosInstance> | null = null;

const getBindApi = async (): Promise<AxiosInstance | null> => {
  if (bindApiPromise) return bindApiPromise;
  bindApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return bindApiPromise;
};

const normalizeProvince = (p: any): BindProvincia | null => {
  const id = typeof p?.id === "number" ? p.id : Number(p?.Id);
  const name = typeof p?.name === "string" ? p.name : p?.Name;
  if (!Number.isFinite(id) || !name) return null;
  return { id, name: String(name) };
};

const normalizeLocality = (l: any): BindLocalidad | null => {
  const id = typeof l?.id === "number" ? l.id : Number(l?.Id);
  const name = typeof l?.name === "string" ? l.name : l?.Name;
  let externalCode: string | undefined;
  if (typeof l?.externalCode === "string") {
    externalCode = l.externalCode;
  } else if (typeof l?.ExternalCode === "string") {
    externalCode = l.ExternalCode;
  }
  if (!Number.isFinite(id) || !name) return null;
  return { id, name: String(name), externalCode };
};

export const getBindProvincias = async (): Promise<BindProvincia[] | null> => {
  const api = await getBindApi();
  if (!api) return null;

  const response = await api.get(`/Bind/provincias`);
  const raw = Array.isArray(response.data) ? response.data : [];
  return raw.map(normalizeProvince).filter((x): x is NonNullable<typeof x> => x !== null);
};

export const getBindLocalidades = async (
  idProvincia: number,
): Promise<BindLocalidad[] | null> => {
  const api = await getBindApi();
  if (!api) return null;

  if (!Number.isFinite(idProvincia) || !idProvincia) return [];

  const queryString = objectToQueryStringWithArray({ IdProvincia: idProvincia });
  const response = await api.get(`/Bind/localidades?${queryString}`);
  const raw = Array.isArray(response.data) ? response.data : [];
  return raw.map(normalizeLocality).filter((x): x is NonNullable<typeof x> => x !== null);
};
